import { getOpportunities } from '@/lib/get-post-opportunities'
import OpportunitiesTable from '@/components/table-archive/OpportunitiesTable'
import { MainColumn, MainColumnLeft, MainColumnRight } from '@/components/main-column/MainColumn'
import { LinkProps } from '@/types/types'
import PostTable from '../post-table/PostTable'

export default async function Opportunities({
  title = 'Latest Opportunities',
  text = '',
  viewAllLink = { title: 'View All', url: '/opportunities/' },
  types,
  sectors,
  lifecycleStages,
  postId,
  fallbackMessage = '<h5>There are currently no opportunities available</h5><p><a href="/working-in-finance/opportunities/" target="_blank">View all opportunities</a></p>',
}: {
  title?: string
  text?: string
  viewAllLink?: LinkProps
  types?: string[]
  sectors?: string[]
  lifecycleStages?: string[]
  postId?: number | string
  fallbackMessage?: string
}): Promise<JSX.Element | null> {
  // Fetch opportunities based on the provided filters
  const opportunities = await getOpportunities({
    types: types,
    sectors: sectors,
    lifecycleStages: lifecycleStages,
    exclude: postId,
    perPage: 10,
  })

  if (fallbackMessage.length === 0) {
    fallbackMessage =
      '<h5>There are currently no opportunities available</h5><p><a href="/working-in-finance/opportunities/" target="_blank">View all opportunities</a></p>'
  }

  return (
    <MainColumn className="mb-xxxl">
      <MainColumnLeft title={title} text={text} button={viewAllLink} />

      <MainColumnRight>
        {opportunities?.length ? (
          <OpportunitiesTable
            columns={['Title', 'Type', 'Sector', 'Organisation', 'Closing Date']}
            opportunities={opportunities}
          />
        ) : (
          <div className="container">
            <PostTable
              items={{
                columns: ['&nbsp;'],
                rows: [
                  [
                    <div
                      className="py-m text-center"
                      dangerouslySetInnerHTML={{ __html: fallbackMessage }}
                    />,
                  ],
                ],
              }}
            />
          </div>
        )}
      </MainColumnRight>
    </MainColumn>
  )
}
